import { CORE_INTERCEPTORS_URL_REGEX_PATTERNS_FILTER } from '@aeins/core';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

let headers: any = null;

export function CustomInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    if (!inject(CORE_INTERCEPTORS_URL_REGEX_PATTERNS_FILTER).some((regex) => request.url.match(regex))) {
        return next(request);
    }

    if (!headers) {
        headers = {
            'X-App-Identifier': 'SelfService',
            'Access-Control-Allow-Origin': '*',
        };
    }

    return next(
        request.clone({
            setHeaders: Object.fromEntries(Object.entries(headers).filter(([, val]) => val)) as any,
        }),
    );
}
